<template>
  <Shell :label="label" :tooltip="tooltip">
    <template v-if="grow" v-slot:label-end>
      <button
        type="button"
        class="text-primary cursor-pointer"
        :aria-label="isExpanded ? 'Shrink value' : 'Grow value'"
        :title="isExpanded ? 'Shrink value' : 'Grow value'"
        @click="isExpanded = !isExpanded"
      >
        <font-awesome-icon :icon="isExpanded ? 'chevron-up' : 'chevron-down'" />
      </button>
    </template>
    <template v-slot:comp>
      <div v-if="loading" class="w-full" style="height: 36px; display: flex; align-items: center;" aria-busy="true" aria-live="polite">
        <div class="animate-pulse space-y-2 w-full">
          <div class="h-3 bg-gray-300 rounded w-3/4"></div>
        </div>
      </div>
      <div v-else :class="`w-full text-sm leading-3 ${
          isExpanded ? '' : 'whitespace-nowrap truncate'
        }`" :style="`line-height: 36px; ${
          !isExpanded
            ? 'height: 36px'
            : 'height: 100%; max-height: 50vh; overflow-y: auto'
        }; background: rgba(0, 0, 0, 0); outline: none;`" :aria-label="value" tabindex="0" role="heading">
        <div v-html="value"></div>
      </div>

      <input type="hidden" :name="name" :value="value" v-if="name && !loading" />
      <font-awesome-icon class="text-primary mr-2 cursor-pointer" icon="eye" @click="goto(link)"
        v-show="!!link && !!value && !loading"></font-awesome-icon>
      <div v-if="!!customIcon && !loading">
        <font-awesome-icon class="text-primary mr-2 cursor-pointer" :icon="customIcon"
          @click="$emit('customIconClicked', value)" v-show="!!customIcon"></font-awesome-icon>
      </div>
    </template>
  </Shell>
</template>
<script setup="props">
import { defineProps, ref } from "vue";
import { useRouter } from "vue-router";

import Shell from "./Shell.vue";
const router = useRouter();
const isExpanded = ref(true);
// define the component props
defineProps({
  link: String,
  label: String,
  value: [String, Number],
  grow: Boolean,
  name: String,
  customIcon: String,
  tooltip: String,
  richtext: Boolean,
  loading: Boolean,
});

const goto = (address) => {
  router.push(address);
};

defineEmits(["customIconClicked"]);

</script>
